document.addEventListener("DOMContentLoaded", () => {
  const initSearchDropdown = () => {
    const wrapper = document.querySelector(".tuya-header__search-categories");
    if (!wrapper) return;

    const toggle = wrapper.querySelector(
      ".tuya-header__search-dropdown-toggle",
    );
    const optionsContainer = wrapper.querySelector(
      ".tuya-header__search-dropdown-options",
    );
    const collectionInput = wrapper
      .closest("form")
      .querySelector(".tuya-header__search-collection-input");
    const selectedLabel = wrapper.querySelector(
      ".tuya-header__search-dropdown-selected",
    );
    const options = wrapper.querySelectorAll(
      ".tuya-header__search-dropdown-option",
    );
    const searchParent = wrapper.closest(".tuya-predictive-search-parent");
    const predictiveContainer = searchParent
      ? searchParent.querySelector(".tuya-predictive-search-results-container")
      : null;

    if (!toggle || !optionsContainer || !selectedLabel) return;

    const closeDropdown = () => {
      optionsContainer.setAttribute("hidden", "");
      wrapper.classList.remove("open");
    };

    const openDropdown = () => {
      document.querySelectorAll(".tuya-localization-dropdown").forEach((d) => {
        const menu = d.querySelector(".tuya-localization-dropdown__menu");
        if (menu) menu.setAttribute("hidden", "");
        d.classList.remove("open");
        const toggle = d.querySelector(".tuya-localization-dropdown__toggle");
        if (toggle) toggle.setAttribute("aria-expanded", "false");
      });

      optionsContainer.removeAttribute("hidden");
      wrapper.classList.add("open");
      if (predictiveContainer) {
        predictiveContainer.setAttribute("hidden", "");
        const input = searchParent.querySelector('input[type="search"]');
        if (input) input.setAttribute("aria-expanded", "false");
      }
    };

    toggle.addEventListener("click", (e) => {
      e.stopPropagation();
      if (optionsContainer.hasAttribute("hidden")) {
        openDropdown();
      } else {
        closeDropdown();
      }
    });

    options.forEach((option) => {
      option.addEventListener("click", (e) => {
        e.stopPropagation();
        const collectionHandle = option.getAttribute("data-collection") || "";
        const text = option.textContent;

        options.forEach((opt) => opt.classList.remove("active"));
        option.classList.add("active");
        selectedLabel.textContent = text;

        if (collectionInput) {
          collectionInput.value = collectionHandle;
        }

        closeDropdown();
      });
    });

    const form = wrapper.closest("form");
    if (form) {
      form.addEventListener("submit", (e) => {
        const collection = collectionInput ? collectionInput.value : "";
        const queryInput = form.querySelector('input[type="search"]');
        const query = queryInput ? queryInput.value.trim() : "";

        if (!query) return;

        e.preventDefault();

        const searchAction =
          form.action ||
          (window.Theme &&
            window.Theme.routes &&
            window.Theme.routes.search_url) ||
          "/search";
        const rootUrl =
          (window.Theme &&
            window.Theme.routes &&
            window.Theme.routes.root_url) ||
          (window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root) ||
          "/";
        const cleanRoot = rootUrl.endsWith("/")
          ? rootUrl.slice(0, -1)
          : rootUrl;

        if (collection) {
          window.location.href =
            cleanRoot +
            "/collections/" +
            encodeURIComponent(collection) +
            "?q=" +
            encodeURIComponent(query);
        } else {
          window.location.href =
            searchAction +
            "?q=" +
            encodeURIComponent(query) +
            "&type=product&options%5Bprefix%5D=last";
        }
      });
    }

    document.addEventListener("click", () => {
      closeDropdown();
    });
  };

  const initPredictiveSearch = () => {
    const searchContainers = document.querySelectorAll(
      ".tuya-predictive-search-parent",
    );
    if (searchContainers.length === 0) return;

    let debounceTimer;

    searchContainers.forEach((container) => {
      const input = container.querySelector('input[type="search"]');
      const resultsContainer = container.querySelector(
        ".tuya-predictive-search-results-container",
      );
      if (!input || !resultsContainer) return;

      const getSelectedCollection = () => {
        const collectionInput = container.querySelector(
          ".tuya-header__search-collection-input",
        );
        return collectionInput ? collectionInput.value : "";
      };

      const performSearch = (query) => {
        if (!query || query.trim().length < 3) {
          resultsContainer.innerHTML = "";
          resultsContainer.setAttribute("hidden", "");
          input.setAttribute("aria-expanded", "false");
          return;
        }

        const categoryDropdown = container.querySelector(
          ".tuya-header__search-dropdown-options",
        );
        const categoryWrapper = container.querySelector(
          ".tuya-header__search-categories",
        );
        if (categoryDropdown && categoryWrapper) {
          categoryDropdown.setAttribute("hidden", "");
          categoryWrapper.classList.remove("open");
        }

        const selectedCollection = getSelectedCollection();
        let resourceTypes = "product,page,article,collection";
        if (selectedCollection) {
          resourceTypes = "product";
        }

        const predictiveSearchUrl =
          (window.Theme &&
            window.Theme.routes &&
            window.Theme.routes.predictive_search_url) ||
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + "search/suggest"
            : "/search/suggest");
        const url =
          predictiveSearchUrl +
          "?q=" +
          encodeURIComponent(query) +
          "&resources[type]=" +
          resourceTypes +
          "&resources[limit]=6" +
          "&section_id=tuya-predictive-search";

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error("Network response error");
            return response.text();
          })
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newContent = doc.querySelector(".tuya-predictive-search");

            if (newContent && newContent.innerHTML.trim() !== "") {
              resultsContainer.innerHTML = newContent.outerHTML;
              resultsContainer.removeAttribute("hidden");
              input.setAttribute("aria-expanded", "true");
            } else {
              resultsContainer.innerHTML = "";
              resultsContainer.setAttribute("hidden", "");
              input.setAttribute("aria-expanded", "false");
            }
          })
          .catch(() => {
            resultsContainer.setAttribute("hidden", "");
          });
      };

      input.addEventListener("input", () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          performSearch(input.value);
        }, 300);
      });

      input.addEventListener("focus", () => {
        if (resultsContainer.innerHTML.trim() !== "") {
          resultsContainer.removeAttribute("hidden");
          input.setAttribute("aria-expanded", "true");

          const categoryDropdown = container.querySelector(
            ".tuya-header__search-dropdown-options",
          );
          const categoryWrapper = container.querySelector(
            ".tuya-header__search-categories",
          );
          if (categoryDropdown && categoryWrapper) {
            categoryDropdown.setAttribute("hidden", "");
            categoryWrapper.classList.remove("open");
          }
        }
      });
    });

    document.addEventListener("click", (e) => {
      searchContainers.forEach((container) => {
        const resultsContainer = container.querySelector(
          ".tuya-predictive-search-results-container",
        );
        const input = container.querySelector('input[type="search"]');
        if (resultsContainer && !container.contains(e.target)) {
          resultsContainer.setAttribute("hidden", "");
          if (input) input.setAttribute("aria-expanded", "false");
        }
      });
    });
  };

  const updateCartCounts = (count) => {
    const cartBadges = document.querySelectorAll(
      ".tuya-header__badge--cart, .tuya-header__nav-bottom-item--cart .tuya-header__cart-count",
    );
    cartBadges.forEach((badge) => {
      badge.textContent = count;
      if (count > 0) {
        badge.style.display = "";
      } else {
        badge.style.display = "none";
      }
    });
  };

  const initLocalizationDropdowns = () => {
    const dropdowns = document.querySelectorAll(".tuya-localization-dropdown");
    if (dropdowns.length === 0) return;

    dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector(
        ".tuya-localization-dropdown__toggle",
      );
      const menu = dropdown.querySelector(".tuya-localization-dropdown__menu");
      const form = dropdown.closest("form");

      if (!toggle || !menu || !form) return;

      const closeDropdown = () => {
        menu.setAttribute("hidden", "");
        dropdown.classList.remove("open");
        toggle.setAttribute("aria-expanded", "false");
      };

      const openDropdown = () => {
        document
          .querySelectorAll(".tuya-localization-dropdown")
          .forEach((d) => {
            if (d !== dropdown) {
              const otherMenu = d.querySelector(
                ".tuya-localization-dropdown__menu",
              );
              if (otherMenu) otherMenu.setAttribute("hidden", "");
              d.classList.remove("open");
              const otherToggle = d.querySelector(
                ".tuya-localization-dropdown__toggle",
              );
              if (otherToggle)
                otherToggle.setAttribute("aria-expanded", "false");
            }
          });

        document
          .querySelectorAll(".tuya-header__search-categories")
          .forEach((w) => {
            const opt = w.querySelector(
              ".tuya-header__search-dropdown-options",
            );
            if (opt) opt.setAttribute("hidden", "");
            w.classList.remove("open");
          });

        menu.removeAttribute("hidden");
        dropdown.classList.add("open");
        toggle.setAttribute("aria-expanded", "true");
      };

      toggle.addEventListener("click", (e) => {
        e.stopPropagation();
        if (menu.hasAttribute("hidden")) {
          openDropdown();
        } else {
          closeDropdown();
        }
      });

      const links = dropdown.querySelectorAll(
        ".tuya-localization-dropdown__link",
      );
      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const value = link.getAttribute("data-value");
          const type = link.getAttribute("data-type");

          if (type === "language") {
            const input = form.querySelector('input[name="locale_code"]');
            if (input) input.value = value;
          } else if (type === "country") {
            const input = form.querySelector('input[name="country_code"]');
            if (input) input.value = value;
          }

          form.submit();
        });
      });

      dropdown.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          closeDropdown();
          toggle.focus();
        }
      });
    });

    document.addEventListener("click", () => {
      dropdowns.forEach((dropdown) => {
        const menu = dropdown.querySelector(
          ".tuya-localization-dropdown__menu",
        );
        if (menu) {
          menu.setAttribute("hidden", "");
          dropdown.classList.remove("open");
          const toggle = dropdown.querySelector(
            ".tuya-localization-dropdown__toggle",
          );
          if (toggle) toggle.setAttribute("aria-expanded", "false");
        }
      });
    });
  };

  document.addEventListener("cart:updated", (e) => {
    if (
      e.detail &&
      e.detail.cart &&
      typeof e.detail.cart.item_count !== "undefined"
    ) {
      updateCartCounts(e.detail.cart.item_count);
    }
  });

  document.addEventListener("cart:update", (e) => {
    if (
      e.detail &&
      e.detail.resource &&
      typeof e.detail.resource.item_count !== "undefined"
    ) {
      updateCartCounts(e.detail.resource.item_count);
    }
  });

  initSearchDropdown();
  initPredictiveSearch();
  initLocalizationDropdowns();

  document.addEventListener("shopify:section:load", (e) => {
    if (e.detail.sectionId.includes("header")) {
      initSearchDropdown();
      initPredictiveSearch();
      initLocalizationDropdowns();
    }
  });
});
